import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CustomizedDataGrid from "./CustomizedDataGrid";
import ConfirmationDialog from "../../shared/CustomConfirmationDialog";
import { useState } from "react";
import { deleteCV, saveCVData } from "../../../services/cvService";
import FrontendCV from "../../../types/FrontendCV";
import { useCVs } from "../../../hooks/useCVs";
import { formatCVForTable } from "../internals/data/gridData";
import { Chip, Divider, Stack } from "@mui/material";
import CustomAddCvDialog from "./customized-dialogs/CustomAddCvDialog";

export default function MainGrid() {
  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    useState<boolean>(false);
  const [addCvDialogOpen, setAddCvDialogOpen] = useState<boolean>(false);

  const [selectedCV, setSelectedCV] = useState<FrontendCV | null>(null);
  const { cvs, loading, loadingMore, fetchCVs } = useCVs();
  const formattedCVs = formatCVForTable(cvs);

  const handleDeleteCVClick = (cv: FrontendCV) => {
    setConfirmationDialogOpen(true);
    setSelectedCV(cv);
  };

  const handleAddCvClick = () => {
    setAddCvDialogOpen(true);
  };

  const handleConfirmAction = async () => {
    if (!selectedCV) return;

    try {
      await deleteCV(selectedCV.id);
      await fetchCVs();
    } catch (error) {
      console.error("Failed to delete CV:", error);
    } finally {
      setConfirmationDialogOpen(false);
      setSelectedCV(null);
    }
  };


  const handleAddCv : any = async (cvToAdd : any) => {
    try {
      const cv = {
        cvId: cvToAdd.cvId,
        cvUId: "",
        name: cvToAdd.name,
        position: {
          positionId: "",
          name: "",
          summary: "",
        },
        professionalSummary: "",
        skills: {
          backend: [],
          cloud: [],
          devOps: [],
          frontend: [],
          others: [],
          tools: [],
          database: [],
        },
        professionalAffiliations: [],
        certifications: [],
        education: [],
        languages: {
          english: "",
          nativeLanguage: "",
          otherLanguages: [],
        },
        status: "active" as "active",
        type: "employee" as "employee",
      }
      await saveCVData(cv);
      await fetchCVs();
      console.log(cv);
    }catch(error: any){
      console.error("Error adding cv:", error);}
    return 0;
  }

  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      {/* Header */}
      <Stack
        direction="row"
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        spacing={2}
        sx={{ mb: 1, mt: 2.5 }}
      >
        <Box>
          <Typography
            component="h2"
            variant="overline"
            sx={{
              color: "text.secondary",
              letterSpacing: 0.8,
              fontWeight: 700,
            }}
          >
            Details
          </Typography>
        </Box>
        <Chip
          size="small"
          label={
            loading
              ? "Loading…"
              : loadingMore
                ? `${formattedCVs.length}+ loading…`
                : `${formattedCVs.length} ${
                    formattedCVs.length === 1 ? "Record" : "Records"
                  }`
          }
          variant="outlined"
          sx={{ alignSelf: { xs: "flex-start", sm: "center" } }}
        />
      </Stack>
      <Divider sx={{ mb: 2 }} />
      {/* cards */}
      <Grid size={{ xs: 12, lg: 9 }}>
        <CustomizedDataGrid
          cvs={formattedCVs}
          loading={loading}
          handleDeleteClick={handleDeleteCVClick}
          handleAddCvClick={handleAddCvClick}
        />
      </Grid>
      
      {/* Add CV Dialog */}
      <CustomAddCvDialog
        open={addCvDialogOpen}
        onClose={() => setAddCvDialogOpen(false)}
        onSave={handleAddCv} cv={undefined}/>


      <ConfirmationDialog
        open={confirmationDialogOpen}
        onClose={() => {
          setConfirmationDialogOpen(false);
          setSelectedCV(null);
        }}
        onConfirm={handleConfirmAction}
        title="Delete CV"
        message="Are you sure you want to delete this CV?"
        confirmColor="secondary"
      />
    </Box>
  );
}
